import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f629641c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrap em-container" }
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动说明", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { computed } from 'vue'
import { useNavInfo } from '@/compositions/common'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'activity-introduce-image',
  setup(__props) {

const imageNumbers = '1234567'.split('')
const $router = useRouter()

const { judgeIsUseAppDefaultNav, getWebviewNavHeightValue } = useNavInfo()

const imageItems = computed(() => {
  return imageNumbers.map((item) => {
    const original = `https://static.knowledge.xag.cn/img/old-brings-new/introduce/0226-0${item}.jpg`
    const webp = `${original}?imageMogr2/format/webp`
    return { original, webp }
  })
})

const tipStyle = computed(() => {
  if (judgeIsUseAppDefaultNav()) {
    return {}
  }
  return {
    marginTop: getWebviewNavHeightValue() + 'px',
  }
})

function toRulePage() {
  $router.push({
    name: 'activity-old-bring-new-rules-page',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageItems), (item) => {
      return (_openBlock(), _createElementBlock("picture", {
        key: item.original,
        class: "image-item"
      }, [
        _createElementVNode("source", {
          srcset: item.webp,
          type: "image/webp"
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          src: item.original,
          alt: ""
        }, null, 8, _hoisted_3)
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: "activity-introduce",
      style: _normalizeStyle(_unref(tipStyle)),
      onClick: toRulePage
    }, _hoisted_5, 4)
  ]))
}
}

})